exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!./../node_modules/roboto-fontface/css/roboto/roboto-fontface.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!../node_modules/@dian-cmp/estilos/styles-diliforms.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n/* Roboto Font */\r\n/* Style framework */\r\n\r\n.truncate-content {\r\n  display: block;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.backdrop-recibo-pago {\r\n\tbackground-color: rgba(0,0,0,0.3);\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/github/490/rec_ng_recibopago490v7/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!D:/github/490/rec_ng_recibopago490v7/node_modules/postcss-loader?{"ident":"postcss"}!D:/github/490/rec_ng_recibopago490v7/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles